import axios from "axios";
import useSWR from "swr";

import { CarrierMapPointDto } from "models/dto/CarrierMapPointDto";
import { CarriersFilter } from "./useCarriersFilter";
import { appendCarrierFilterParams } from "./carrierFilterParams";

const baseUrl = "/api/carriers/map";

const useGetCarriersMap = (carriersFilter: CarriersFilter) => {
  const params = appendCarrierFilterParams(
    new URLSearchParams(),
    carriersFilter
  );

  const url = `${baseUrl}?${params.toString()}`;

  const { data, error, isLoading } = useSWR(url, (requestUrl: string) =>
    axios
      .get<CarrierMapPointDto[]>(requestUrl)
      .then((response) => response.data)
  );

  return {
    carrierPoints: data ?? [],
    isLoading,
    error,
  };
};

export default useGetCarriersMap;
